// extracted by mini-css-extract-plugin
export default {"containerIcon":"Login_containerIcon__DW2Do","container":"Login_container__l-I3t","title":"Login_title__wGEyJ","text":"Login_text__3B6+b","copyright":"Login_copyright__qt734"};